export const videos = [
  {
    id: "v1",
    title: "星际回响",
    subtitle: "当人类的信号穿越千年，宇宙终于有了回应",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20key%20art%20of%20a%20lone%20astronaut%20silhouette%20facing%20a%20vast%20glowing%20nebula%2C%20deep%20blue%20and%20teal%20cosmic%20tones%20with%20warm%20orange%20rim%20light%2C%20dramatic%20volumetric%20lighting%2C%20stylized%20digital%20painting%2C%20ultra%20detailed%2C%20epic%20cinematic%20film%20composition&width=800&height=450&seq=qc-video-01&orientation=landscape",
    categoryId: "film",
    categoryName: "影视剧",
    tags: ["科幻", "太空", "冒险", "欧美剧"],
    region: "美国",
    genre: "科幻",
    year: 2025,
    duration: "02:18:00",
    durationMinutes: 138,
    plays: 3286000,
    favorites: 128000,
    uploadTime: "2026-09-28",
    uploader: "一起草影视",
    description: "一个深空信号接收站意外捕捉到来自千年之外的回响，一支临时组建的探索小队踏上未知旅程。他们要在有限时间里解开信号背后的真相，而答案远比想象中更接近人类自身。",
  },
  {
    id: "v2",
    title: "暗涌之城",
    subtitle: "每一盏霓虹灯下，都藏着不愿被说出的秘密",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20still%20of%20a%20rainy%20night%20city%20street%20with%20wet%20reflective%20asphalt%2C%20deep%20blue%20shadows%20and%20warm%20orange%20street%20lamp%20glow%2C%20moody%20suspenseful%20atmosphere%2C%20stylized%20photographic%20art%2C%20ultra%20detailed%2C%20widescreen%20cinematic%20composition&width=800&height=450&seq=qc-video-02&orientation=landscape",
    categoryId: "film",
    categoryName: "影视剧",
    tags: ["悬疑", "都市", "犯罪", "电视剧"],
    region: "中国大陆",
    genre: "悬疑",
    year: 2026,
    duration: "00:45:00",
    durationMinutes: 45,
    plays: 2145000,
    favorites: 96000,
    uploadTime: "2026-10-06",
    uploader: "一起草影视",
    description: "雨夜的城市表面平静，暗流却在每条街道下涌动。一名坚持追查旧案的记者与一位不愿回忆的目击者，被同一段真相重新拉回漩涡中心。",
  },
  {
    id: "v3",
    title: "山海归途",
    subtitle: "走过最远的路，是为了回到最初的家",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20film%20still%20of%20misty%20layered%20mountains%20at%20dawn%20with%20a%20solitary%20traveler%20on%20a%20winding%20path%2C%20cool%20blue%20mist%20and%20soft%20golden%20sunrise%20light%2C%20poetic%20atmospheric%20mood%2C%20stylized%20digital%20painting%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-03&orientation=landscape",
    categoryId: "film",
    categoryName: "影视剧",
    tags: ["剧情", "亲情", "治愈", "电影"],
    region: "中国大陆",
    genre: "剧情",
    year: 2024,
    duration: "01:52:00",
    durationMinutes: 112,
    plays: 1782000,
    favorites: 82000,
    uploadTime: "2026-08-14",
    uploader: "山海影像",
    description: "离乡多年的主人公带着一段未完成的承诺，沿着儿时的山路重新走了一遍故乡。沿途遇见的人与事，让这场归途变成一次与自己的和解。",
  },
  {
    id: "v4",
    title: "孤岛黎明",
    subtitle: "风暴过后，灯塔是唯一还在亮着的东西",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20film%20still%20of%20a%20lonely%20lighthouse%20on%20a%20rocky%20island%20at%20cold%20blue%20dawn%2C%20crashing%20waves%20and%20dramatic%20clouds%2C%20deep%20teal%20and%20grey%20palette%20with%20small%20warm%20light%2C%20stylized%20digital%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-04&orientation=landscape",
    categoryId: "film",
    categoryName: "影视剧",
    tags: ["悬疑", "孤岛", "人性", "欧美剧"],
    region: "英国",
    genre: "悬疑",
    year: 2025,
    duration: "00:52:00",
    durationMinutes: 52,
    plays: 1324000,
    favorites: 61000,
    uploadTime: "2026-07-22",
    uploader: "远岸剧集",
    description: "一座只有一名守塔人的孤岛，在风暴季迎来了三位不请自来的访客。当黎明来临，谁说的是真话，谁又在隐藏自己，都将在灯塔的光里被看清。",
  },
  {
    id: "v5",
    title: "长风万里",
    subtitle: "最快的刀，也追不上一个人下定的决心",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20action%20film%20key%20art%20of%20a%20lone%20warrior%20walking%20through%20a%20vast%20golden%20desert%20with%20swirling%20dust%2C%20warm%20orange%20sand%20tones%20and%20dramatic%20backlight%2C%20epic%20dynamic%20composition%2C%20stylized%20digital%20painting%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-05&orientation=landscape",
    categoryId: "film",
    categoryName: "影视剧",
    tags: ["动作", "武侠", "冒险", "电影"],
    region: "中国大陆",
    genre: "动作",
    year: 2026,
    duration: "02:05:00",
    durationMinutes: 125,
    plays: 2891000,
    favorites: 115000,
    uploadTime: "2026-09-30",
    uploader: "长风工作室",
    description: "边陲小镇上，一名退役的护送者接下最后一单委托，护送一份关系到千万人安危的信物穿越荒漠。追兵、沙暴与旧日恩怨，让这趟路变得前所未有的艰难。",
  },
  {
    id: "v6",
    title: "玻璃花园",
    subtitle: "有些感情，只在透明的世界里生长",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20film%20still%20of%20a%20dreamy%20glass%20greenhouse%20filled%20with%20blooming%20flowers%20and%20soft%20sunlight%20beams%2C%20warm%20peach%20and%20rose%20tones%20with%20gentle%20bokeh%2C%20soft%20romantic%20atmosphere%2C%20stylized%20photographic%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-06&orientation=landscape",
    categoryId: "film",
    categoryName: "影视剧",
    tags: ["爱情", "文艺", "都市", "电影"],
    region: "法国",
    genre: "爱情",
    year: 2024,
    duration: "01:44:00",
    durationMinutes: 104,
    plays: 986000,
    favorites: 54000,
    uploadTime: "2026-06-18",
    uploader: "一起草影视",
    description: "一位植物学家与一位玻璃工艺师在同一座温室里共事了一个夏天。透明而脆弱的相处让两人慢慢靠近，也让他们必须面对各自的过去。",
  },
  {
    id: "v7",
    title: "午夜列车",
    subtitle: "这趟车的目的地，没人愿意提起",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20eerie%20film%20still%20of%20an%20old%20night%20train%20passing%20through%20dark%20fog%2C%20flickering%20cold%20blue%20lights%20and%20a%20single%20warm%20window%2C%20tense%20suspenseful%20mood%2C%20stylized%20digital%20art%2C%20ultra%20detailed%2C%20cinematic%20composition&width=800&height=450&seq=qc-video-07&orientation=landscape",
    categoryId: "film",
    categoryName: "影视剧",
    tags: ["悬疑", "惊悚", "列车", "电影"],
    region: "韩国",
    genre: "悬疑",
    year: 2025,
    duration: "01:38:00",
    durationMinutes: 98,
    plays: 1567000,
    favorites: 73000,
    uploadTime: "2026-08-02",
    uploader: "暗夜放映室",
    description: "一列只在午夜运行的旧式列车，载着六位互不相识的乘客驶入浓雾。随着车窗外景物一次次重复，他们开始意识到，这趟旅程考验的是彼此的信任。",
  },
  {
    id: "v8",
    title: "时间褶皱",
    subtitle: "如果有第二次机会，你会改变哪一个瞬间",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20sci%20fi%20visual%20of%20distorted%20concentric%20clock%20rings%20and%20light%20trails%20folding%20through%20space%2C%20deep%20blue%20and%20cyan%20tones%20with%20orange%20accents%2C%20futuristic%20concept%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-08&orientation=landscape",
    categoryId: "film",
    categoryName: "影视剧",
    tags: ["科幻", "时间", "剧情", "电影"],
    region: "美国",
    genre: "科幻",
    year: 2026,
    duration: "02:12:00",
    durationMinutes: 132,
    plays: 2412000,
    favorites: 103000,
    uploadTime: "2026-10-02",
    uploader: "未来影像社",
    description: "一位物理学家在一次实验意外后获得了重看某个瞬间的能力。为了弥补一个无法挽回的遗憾，他一次次回到过去，却发现每一次更改都带来新的代价。",
  },
  {
    id: "v9",
    title: "星光盛典现场",
    subtitle: "年度最闪耀的舞台，与你一同见证",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20grand%20award%20ceremony%20stage%20with%20golden%20spotlights%2C%20glowing%20bokeh%20particles%20and%20elegant%20stage%20design%2C%20warm%20amber%20and%20deep%20blue%20contrast%2C%20glamorous%20atmosphere%2C%20stylized%20digital%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-09&orientation=landscape",
    categoryId: "entertainment",
    categoryName: "娱乐",
    tags: ["明星", "现场", "盛典"],
    region: "中国大陆",
    genre: "音乐",
    year: 2026,
    duration: "01:30:00",
    durationMinutes: 90,
    plays: 3621000,
    favorites: 142000,
    uploadTime: "2026-10-08",
    uploader: "星光娱乐",
    description: "一年一度的星光盛典完整回顾，红毯、颁奖与高光舞台一次看全。数十组表演嘉宾轮番登场，用音乐点亮整个夜晚。",
  },
  {
    id: "v10",
    title: "音乐现场·不眠夜",
    subtitle: "让鼓点和灯光带你彻夜不睡",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20live%20concert%20stage%20with%20silhouetted%20crowd%2C%20sweeping%20colored%20spotlights%20and%20dramatic%20haze%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20energetic%20atmosphere%2C%20stylized%20digital%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-10&orientation=landscape",
    categoryId: "entertainment",
    categoryName: "娱乐",
    tags: ["音乐", "现场", "演唱会"],
    region: "中国大陆",
    genre: "音乐",
    year: 2025,
    duration: "01:05:00",
    durationMinutes: 65,
    plays: 2213000,
    favorites: 89000,
    uploadTime: "2026-09-19",
    uploader: "现场电台",
    description: "收录今年最受欢迎的现场演出片段，从开场到安可全程高能。跟着节奏一起摇摆，把所有的疲惫都留在音乐里。",
  },
  {
    id: "v11",
    title: "明星面对面",
    subtitle: "每一次真诚的对话，都离他们更近一点",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20studio%20portrait%20scene%20of%20an%20elegant%20talk%20show%20set%20with%20soft%20warm%20rim%20lighting%20and%20a%20blurred%20minimal%20background%2C%20refined%20editorial%20mood%2C%20stylized%20photographic%20art%2C%20ultra%20detailed%2C%20harmonious%20composition&width=800&height=450&seq=qc-video-11&orientation=landscape",
    categoryId: "entertainment",
    categoryName: "娱乐",
    tags: ["明星", "访谈", "对话"],
    region: "中国大陆",
    genre: "生活",
    year: 2026,
    duration: "00:48:00",
    durationMinutes: 48,
    plays: 1376000,
    favorites: 57000,
    uploadTime: "2026-10-04",
    uploader: "面对面工作室",
    description: "走进演播室，与不同领域的创作者坐下来慢慢聊。没有脚本，没有套路，只有关于选择、坚持与热爱的真实分享。",
  },
  {
    id: "v12",
    title: "潮流现场秀",
    subtitle: "这一季的流行，从这里开始",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20fashion%20runway%20show%20with%20glowing%20lights%20and%20motion%20blur%2C%20modern%20elegant%20styling%20in%20warm%20neutral%20and%20cool%20blue%20tones%2C%20trendy%20vibrant%20atmosphere%2C%20stylized%20digital%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-12&orientation=landscape",
    categoryId: "entertainment",
    categoryName: "娱乐",
    tags: ["时尚", "走秀", "潮流"],
    region: "法国",
    genre: "生活",
    year: 2025,
    duration: "00:36:00",
    durationMinutes: 36,
    plays: 842000,
    favorites: 41000,
    uploadTime: "2026-09-06",
    uploader: "潮流频道",
    description: "直击本季最受关注的时装现场，从面料到剪裁，从台步到灯光，一次看懂潮流背后的设计语言。",
  },
  {
    id: "v13",
    title: "三分钟看懂宇宙",
    subtitle: "把 138 亿年，装进一杯咖啡的时间里",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20educational%20illustration%20of%20a%20colorful%20spiral%20galaxy%20with%20planets%20and%20stars%20on%20a%20deep%20navy%20background%2C%20clean%20flat%20design%20with%20soft%20gradients%2C%20modern%20science%20visual%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-13&orientation=landscape",
    categoryId: "shortvideo",
    categoryName: "短视频",
    tags: ["知识", "科普", "宇宙"],
    region: "中国大陆",
    genre: "纪实",
    year: 2026,
    duration: "00:03:20",
    durationMinutes: 3,
    plays: 4128000,
    favorites: 168000,
    uploadTime: "2026-10-09",
    uploader: "小宇宙科普",
    description: "用三分钟带你快速走一遍宇宙的诞生与成长，从大爆炸到星系形成，用最直观的画面解释最宏大的问题。",
  },
  {
    id: "v14",
    title: "街头美食日记",
    subtitle: "深夜的烟火气，才是最治愈的味道",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cozy%20food%20photography%20of%20street%20food%20sizzling%20on%20a%20grill%20with%20rising%20steam%2C%20rich%20orange%20and%20golden%20tones%20on%20a%20simple%20blurred%20background%2C%20appetizing%20editorial%20style%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-14&orientation=landscape",
    categoryId: "shortvideo",
    categoryName: "短视频",
    tags: ["美食", "生活", "探店"],
    region: "中国大陆",
    genre: "生活",
    year: 2026,
    duration: "00:06:40",
    durationMinutes: 6,
    plays: 2763000,
    favorites: 119000,
    uploadTime: "2026-10-07",
    uploader: "深夜食堂君",
    description: "跟着镜头逛遍城市里最受欢迎的夜市摊位，记录老板们的手艺与故事，也记录每一个认真吃饭的夜晚。",
  },
  {
    id: "v15",
    title: "治愈系猫咪日常",
    subtitle: "它什么都不用做，就足够让人放松",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20soft%20photography%20of%20a%20fluffy%20cat%20curled%20up%20sleeping%20near%20a%20sunny%20window%2C%20warm%20beige%20and%20cream%20tones%20with%20gentle%20light%2C%20calm%20healing%20mood%2C%20minimal%20clean%20background%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-15&orientation=landscape",
    categoryId: "shortvideo",
    categoryName: "短视频",
    tags: ["萌宠", "治愈", "生活"],
    region: "中国大陆",
    genre: "生活",
    year: 2026,
    duration: "00:04:10",
    durationMinutes: 4,
    plays: 1892000,
    favorites: 96000,
    uploadTime: "2026-10-05",
    uploader: "猫屋日记",
    description: "记录一只猫从清晨到傍晚的小小日常，晒太阳、打盹、追光斑。没有剧情，只有让人放松下来的温柔画面。",
  },
  {
    id: "v16",
    title: "极限滑板瞬间",
    subtitle: "每一次腾空，都在和地心引力讨价还价",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20action%20photography%20of%20a%20skateboarder%20mid%20air%20trick%20in%20an%20urban%20concrete%20plaza%2C%20warm%20golden%20hour%20light%20with%20cool%20blue%20shadows%2C%20energetic%20motion%20blur%20background%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-16&orientation=landscape",
    categoryId: "shortvideo",
    categoryName: "短视频",
    tags: ["运动", "极限", "才艺"],
    region: "美国",
    genre: "生活",
    year: 2025,
    duration: "00:07:30",
    durationMinutes: 7,
    plays: 1456000,
    favorites: 68000,
    uploadTime: "2026-09-24",
    uploader: "街头运动社",
    description: "跟拍一组滑板爱好者挑战城市里的经典点位，从起跳到落地，用慢镜头拆解每一个高难度动作的细节。",
  },
  {
    id: "v17",
    title: "一分钟学做咖啡",
    subtitle: "在家也能复刻那杯陪你熬夜的拿铁",
    cover: "https://readdy.ai/api/search-image?query=Stylish%20close%20up%20of%20a%20barista%20pouring%20latte%20art%20into%20a%20white%20cup%2C%20warm%20caramel%20and%20cream%20tones%20with%20soft%20window%20light%2C%20minimal%20clean%20cafe%20background%2C%20editorial%20photography%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-17&orientation=landscape",
    categoryId: "shortvideo",
    categoryName: "短视频",
    tags: ["美食", "教程", "生活"],
    region: "中国大陆",
    genre: "生活",
    year: 2026,
    duration: "00:01:45",
    durationMinutes: 1,
    plays: 1128000,
    favorites: 52000,
    uploadTime: "2026-10-01",
    uploader: "一杯慢生活",
    description: "用最简单的器具，一分钟教你打出稳定的奶泡并完成一次拉花。新手也能轻松上手，从今天开始认真对待每一杯咖啡。",
  },
  {
    id: "v18",
    title: "欢乐大冲关",
    subtitle: "掉进水里也没关系，快乐才是重点",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20still%20of%20a%20fun%20game%20show%20obstacle%20course%20with%20bright%20lights%20and%20playful%20stage%20design%2C%20energetic%20orange%20blue%20and%20yellow%20palette%2C%20joyful%20festive%20atmosphere%2C%20stylized%20digital%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-18&orientation=landscape",
    categoryId: "variety",
    categoryName: "综艺",
    tags: ["真人秀", "搞笑", "闯关"],
    region: "中国大陆",
    genre: "喜剧",
    year: 2026,
    duration: "01:20:00",
    durationMinutes: 80,
    plays: 3078000,
    favorites: 134000,
    uploadTime: "2026-10-03",
    uploader: "欢乐综艺社",
    description: "全新一季水上闯关挑战赛，来自各行各业的选手组队挑战高难度关卡。摔倒、翻车与逆袭轮番上演，笑点与热血齐飞。",
  },
  {
    id: "v19",
    title: "一起去旅行吧",
    subtitle: "路过的风景，最终都会变成故事",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20travel%20still%20of%20a%20scenic%20coastal%20road%20with%20mountains%20and%20sea%20at%20sunset%2C%20warm%20golden%20and%20teal%20tones%2C%20fresh%20adventurous%20mood%2C%20stylized%20photographic%20art%2C%20ultra%20detailed%2C%20widescreen%20composition&width=800&height=450&seq=qc-video-19&orientation=landscape",
    categoryId: "variety",
    categoryName: "综艺",
    tags: ["真人秀", "旅行", "治愈"],
    region: "中国大陆",
    genre: "生活",
    year: 2025,
    duration: "01:10:00",
    durationMinutes: 70,
    plays: 1934000,
    favorites: 87000,
    uploadTime: "2026-09-15",
    uploader: "在路上制作组",
    description: "几位性格迥异的嘉宾组队自驾出发，在有限的预算里完成一份旅行清单。一路上的摩擦与默契，让这趟旅程变得格外真实。",
  },
  {
    id: "v20",
    title: "脱口秀夜现场",
    subtitle: "生活再怎么离谱，也值得被笑着讲出来",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20stand%20up%20comedy%20stage%20with%20a%20single%20vintage%20microphone%20in%20a%20warm%20spotlight%2C%20deep%20dark%20background%20with%20amber%20glow%2C%20intimate%20theatrical%20mood%2C%20stylized%20digital%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-20&orientation=landscape",
    categoryId: "variety",
    categoryName: "综艺",
    tags: ["脱口秀", "喜剧", "现场"],
    region: "中国大陆",
    genre: "喜剧",
    year: 2026,
    duration: "00:55:00",
    durationMinutes: 55,
    plays: 2541000,
    favorites: 108000,
    uploadTime: "2026-10-05",
    uploader: "夜现场喜剧",
    description: "汇集本季最受欢迎的脱口秀片段，从通勤到加班，从相亲到养宠，把日常里那些哭笑不得的瞬间讲给你听。",
  },
  {
    id: "v21",
    title: "厨房小当家",
    subtitle: "把家常菜，做成值得纪念的味道",
    cover: "https://readdy.ai/api/search-image?query=Warm%20bright%20still%20of%20a%20modern%20home%20kitchen%20counter%20with%20fresh%20colorful%20ingredients%20and%20cooking%20utensils%2C%20clean%20cream%20and%20warm%20wood%20tones%2C%20cheerful%20cozy%20mood%2C%20stylized%20photographic%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-21&orientation=landscape",
    categoryId: "variety",
    categoryName: "综艺",
    tags: ["选秀", "美食", "竞赛"],
    region: "中国大陆",
    genre: "生活",
    year: 2025,
    duration: "01:00:00",
    durationMinutes: 60,
    plays: 1287000,
    favorites: 59000,
    uploadTime: "2026-08-28",
    uploader: "美味厨房",
    description: "几位素人厨师同台比拼，用有限的食材完成一道道家常创意菜。评委是普通食客，打分的标准只有一个——好吃。",
  },
  {
    id: "v22",
    title: "幻境少年",
    subtitle: "当你相信光，世界就会回应你",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20key%20visual%20of%20a%20young%20hero%20standing%20on%20a%20floating%20island%20surrounded%20by%20glowing%20magic%20energy%2C%20vivid%20blue%20and%20orange%20sky%2C%20detailed%20hand%20painted%20illustration%2C%20epic%20fantasy%20atmosphere%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-22&orientation=landscape",
    categoryId: "anime",
    categoryName: "动漫",
    tags: ["国漫", "奇幻", "热血"],
    region: "中国大陆",
    genre: "动画",
    year: 2026,
    duration: "00:24:00",
    durationMinutes: 24,
    plays: 3452000,
    favorites: 156000,
    uploadTime: "2026-10-08",
    uploader: "幻境动画",
    description: "失去记忆的少年在浮空岛屿上醒来，发现自己能唤起一种古老的光之力。为了找回身世，他与伙伴们踏上穿越幻境的旅程。",
  },
  {
    id: "v23",
    title: "机械纪元",
    subtitle: "当钢铁学会思考，人类该走向何方",
    cover: "https://readdy.ai/api/search-image?query=Anime%20mecha%20key%20visual%20of%20a%20towering%20robot%20in%20a%20futuristic%20city%20at%20dusk%2C%20sleek%20metal%20details%20with%20glowing%20blue%20accents%20and%20orange%20sunset%20light%2C%20dynamic%20detailed%20illustration%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-23&orientation=landscape",
    categoryId: "anime",
    categoryName: "动漫",
    tags: ["日漫", "机甲", "科幻"],
    region: "日本",
    genre: "动画",
    year: 2025,
    duration: "00:23:00",
    durationMinutes: 23,
    plays: 2817000,
    favorites: 132000,
    uploadTime: "2026-09-26",
    uploader: "纪元动画",
    description: "在新纪元的世界里，人类与机械共存却又彼此警惕。一群年轻的机师驾驶着初代机体，试图在冲突中寻找共存的可能。",
  },
  {
    id: "v24",
    title: "妖怪杂货铺",
    subtitle: "你想要的，这里都能找到——但要付出代价",
    cover: "https://readdy.ai/api/search-image?query=Warm%20whimsical%20anime%20illustration%20of%20a%20cozy%20japanese%20yokai%20curiosity%20shop%20at%20night%2C%20glowing%20paper%20lanterns%20and%20colorful%20tiny%20spirits%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20charming%20detailed%20art%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-24&orientation=landscape",
    categoryId: "anime",
    categoryName: "动漫",
    tags: ["日漫", "治愈", "奇幻"],
    region: "日本",
    genre: "动画",
    year: 2026,
    duration: "00:12:00",
    durationMinutes: 12,
    plays: 1638000,
    favorites: 74000,
    uploadTime: "2026-09-12",
    uploader: "杂货铺小组",
    description: "深夜才开门的小杂货铺里，店主与形形色色的妖怪做着各种交易。每个客人都带着一个愿望，也都要为它付出相应的代价。",
  },
  {
    id: "v25",
    title: "蓝色星球之下",
    subtitle: "人类只探索了海洋的百分之五",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20documentary%20still%20of%20a%20deep%20blue%20ocean%20with%20a%20majestic%20whale%20silhouette%20and%20shafts%20of%20sunlight%2C%20rich%20teal%20and%20blue%20tones%20with%20soft%20particles%2C%20serene%20majestic%20mood%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-25&orientation=landscape",
    categoryId: "documentary",
    categoryName: "纪录片",
    tags: ["自然", "海洋", "科普"],
    region: "英国",
    genre: "纪实",
    year: 2025,
    duration: "00:50:00",
    durationMinutes: 50,
    plays: 2146000,
    favorites: 101000,
    uploadTime: "2026-09-08",
    uploader: "自然纪录社",
    description: "潜入深海的黑暗与寂静，记录那些从未被镜头捕捉过的生命形态。带你认识一个比陆地更广阔、也更神秘的世界。",
  },
  {
    id: "v26",
    title: "古埃及之谜",
    subtitle: "金字塔的每一块石头，都写满了未解的问题",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20still%20of%20ancient%20egyptian%20pyramids%20in%20golden%20desert%20dunes%20at%20sunset%2C%20warm%20sand%20and%20amber%20tones%20with%20long%20shadows%2C%20mysterious%20majestic%20atmosphere%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-26&orientation=landscape",
    categoryId: "documentary",
    categoryName: "纪录片",
    tags: ["历史", "人文", "考古"],
    region: "英国",
    genre: "纪实",
    year: 2024,
    duration: "00:46:00",
    durationMinutes: 46,
    plays: 1542000,
    favorites: 69000,
    uploadTime: "2026-07-30",
    uploader: "历史探秘",
    description: "跟随考古团队的脚步，重新审视那些关于古埃及的经典猜想。从建造技术到宗教信仰，一点点拼凑出被时间掩埋的真相。",
  },
  {
    id: "v27",
    title: "未来之城",
    subtitle: "我们正在建造的，是明天的日常",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20concept%20art%20of%20a%20futuristic%20smart%20city%20skyline%20at%20blue%20hour%20with%20glowing%20lights%20and%20elevated%20transit%2C%20deep%20blue%20tones%20with%20warm%20orange%20accents%2C%20clean%20high%20tech%20mood%2C%20ultra%20detailed&width=800&height=450&seq=qc-video-27&orientation=landscape",
    categoryId: "documentary",
    categoryName: "纪录片",
    tags: ["科技", "人文", "未来"],
    region: "中国大陆",
    genre: "纪实",
    year: 2026,
    duration: "00:42:00",
    durationMinutes: 42,
    plays: 1873000,
    favorites: 85000,
    uploadTime: "2026-09-30",
    uploader: "未来观察局",
    description: "走访多个正在建设中的智慧城市，看看科技如何改变出行、能源与居住。未来并不遥远，它就发生在今天的街道上。",
  },
];

export const featuredIds = ["v1", "v9", "v22", "v5", "v13"];